export default {"src":"/_next/static/media/enumerating-services.7d8ffda3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};